import { Component, Input, OnInit } from '@angular/core';
import { AddNewLeadFormComponent } from '../add-new-lead-form/add-new-lead-form.component';
import { MatDialog } from '@angular/material/dialog';
import { GetCountryData } from 'app/store/country/country-data.actions';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-add-new-lead-button',
  templateUrl: './add-new-lead-button.component.html',
  styleUrls: ['./add-new-lead-button.component.scss', '../../form-core/formly/formly-grid-styles.scss']
})
export class AddNewLeadButtonComponent implements OnInit {

  constructor(private dialog: MatDialog,
    private store: Store) {
    this.store.dispatch(new GetCountryData());
  }

  ngOnInit(): void {}

  openDialog() {
    this.dialog.open(AddNewLeadFormComponent, {
      width: '30rem',
      maxHeight: '100vh',
      panelClass: 'addNewLeadDialogContainer',
    });
  }

}
